export const createDateFromTimeString = (timeString) => {
  const today = new Date();
  const [hours, minutes, seconds] = timeString.split(":");

  const date = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate(),
    parseInt(hours),
    parseInt(minutes),
    parseInt(seconds)
  );

  return date.toISOString();
};

/**
 * Formats a date string to display the week of the month and the month name in pt-BR.
 * e.g., "1ª semana de Julho"
 * @param {string} dateString - The date string to format.
 * @returns {string} The formatted string.
 */
export const getWeekOfMonthDisplay = (dateString) => {
  if (!dateString) {
    return "";
  }

  const date = new Date(dateString);
  if (isNaN(date.getTime())) {
    return "Data inválida";
  }

  // Get the week number of the month (1-5)
  const dayOfMonth = date.getDate();
  const weekOfMonth = Math.ceil(dayOfMonth / 7);

  // Get the full month name in Portuguese (Brazil)
  const monthName = new Intl.DateTimeFormat("pt-BR", { month: "long" }).format(
    date
  );

  // Capitalize the first letter of the month for better presentation
  const capitalizedMonthName =
    monthName.charAt(0).toUpperCase() + monthName.slice(1);

  return `${weekOfMonth}ª semana de ${capitalizedMonthName}`;
};
